import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SymbolMappingFilterAction } from './symbolMappingFilter.action';
import { symbolMappingFilterInitialState } from './symbolMappingFilter.constant';

export const symbolMappingFilterReducer = reducerWithInitialState(symbolMappingFilterInitialState)
  .case(SymbolMappingFilterAction.setFilter, (state, payload) => {
    return {
      ...state,
      filter: state.filter === payload ? undefined : payload,
    };
  })
  .cases([SymbolMappingFilterAction.destroy, SymbolMappingFilterAction.clearFilter], () => ({
    ...symbolMappingFilterInitialState,
  }));
